<template>
  <div>
    <div :style="`display:flex;height:${height};`">
      <div :style="`width:${height};height:${height}`">
        <img :loading="imgLazy ? 'lazy' : null" class="img" :src="model.Img" />
      </div>
      <div class="productInfo">
        <div class="title">
          <div class="title-content">
            <van-tag color="#0166b8" v-if="model.Label">{{
              model.Label
            }}</van-tag>
            <span style="padding-left: 5px">{{
              productNameFormatter(model.Title, 30)
            }}</span>
          </div>
        </div>
        <div class="price">
          <div>
            <!-- <span style="letter-spacing: -4.5px">￥</span> -->
            <span style="font-size: 20px">{{ prefixPrice }}.</span>
            <span>{{ suffixPrice }}</span>
          </div>
          <div class="shopping-cart" v-if="visableShoppingCart">
            <slot name="shopping-cart">
              <van-icon
                name="cart-circle"
                color="#0166b8"
                size="25px"
                v-if="!badge"
                @click="addCart" />
              <van-stepper
                v-else
                min="0"
                :value="badge"
                theme="round"
                button-size="22"
                disable-input
                @change="countChange" />
            </slot>
          </div>
        </div>
      </div>
    </div>
    <van-divider
      :style="{
        borderColor: '#C0C0C0',
        padding: '0 16px',
        margin: '2px 0'
      }"></van-divider>
  </div>
</template>

<script>
export default {
  name: 'product-item',
  props: {
    model: Object,
    height: {
      Type: Number,
      default: '80px'
    },
    visableShoppingCart: {
      Type: Boolean,
      default: false
    },
    badge: Number,
    imgLazy: {
      Type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    prefixPrice() {
      return parseInt(this.model.Price)
    },
    suffixPrice() {
      let price = this.model.Price.toString()
      let index = price.indexOf('.')
      if (index >= 0) {
        return price.substr(index + 1)
      }
      return '0'
    }
  },
  methods: {
    countChange(e) {
      this.$emit('countChange', this.model, e)
    },
    addCart() {
      this.$emit('countChange', this.model, 1)
    },
    productNameFormatter(name, maxlength) {
      if (name.length > maxlength) {
        return name.substr(0, maxlength) + '...'
      }
      return name
    }
  }
}
</script>
<style scoped>
.img {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.productInfo {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 10px 0px 10px;
}
.title {
  flex: 3;
  font-size: 15px;
  max-height: 50px;
}
.title-content {
  overflow: hidden;
  /* text-overflow: ellipsis; 超出部分省略号 */
  word-break: break-all; /* break-all(允许在单词内换行。) */
  /* display: -webkit-box; 对象作为伸缩盒子模型显示 */
  /* -webkit-box-orient: vertical; 设置或检索伸缩盒对象的子元素的排列方式 */
  /* -webkit-line-clamp: 2; 显示的行数 */
  /* max-height: 80rpx; 设置最大高度，根据行高，要几行乘以几倍 */
}
.price {
  flex: 1;
  color: red;
  font-weight: bold;
  display: flex;
  align-items: end;
  position: relative;
}
.shopping-cart {
  display: inline-block;
  position: absolute;
  right: 20px;
  bottom: 3px;
}
</style>
